import ModelAccount from "@models/v2/account/ModelAccount";
import {FirebaseService} from "@/services/firebase/FirebaseService";
import DocumentPurchase from "@/services/firebase/firestore/documents/DocumentPurchase";
import {DocumentTypes} from "@/services/firebase/firestore/documents/DocumentTypes";
import {ref} from "vue";

/**
 * Full name: Service external withdrawal control
 * The service is responsible for handling the behavior when a user has withdrawn money at least once in Bromoney, and it affects the UI
 */
export default class ServiceExtWFlow {
  private _isFirebaseExtWFlowEnabled = ref<boolean>(Boolean(import.meta.env.VITE_PURCHASE_IS_EXT_W_FLOW_ENABLED));

  public canUseExtWFlow(account: ModelAccount) {
    const wallet = account.wallet;

    if (!(wallet?.enabled && wallet.balance?.currency)) {
      return false;
    }

    const firebase = FirebaseService.of();
    if (firebase.isInitialized()) {
      return this._isFirebaseExtWFlowEnabled.value && wallet.enabled;
    }

    return wallet.enabled;
  }

  public initFirebaseExtWFlowEnabled() {
    const doc = FirebaseService.of().firestoreService?.getDocument<DocumentPurchase>(DocumentTypes.PURCHASE);
    if (doc) {
      if (doc.isExtWFlowEnabled) {
        this._isFirebaseExtWFlowEnabled.value = true;
      }
    }
  }

  get getFirebaseExtWFlowEnabled() {
    return this._isFirebaseExtWFlowEnabled;
  }
}
